import * as React from 'react';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { Link, useLocation } from 'react-router-dom';
import ListItemButton from '@mui/material/ListItemButton';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

const useStyles = makeStyles()((theme) => ({
    link: {
    },
    disabled: {
        cursor: "default",
    },
    text: {
        whiteSpace: "normal",
        overflowWrap: "anywhere"
    }
}));

export default function MenuItem(props) {
    const {
        url = "",
        label = "",
        Icon = CheckBoxOutlineBlankIcon,
        iconColor = "inherit",
        disabled = false,
        sx = {}
    } = props;

    const { classes } = useStyles();

    const location = useLocation();
    const theme = useTheme();

    return (
        <Link
            to={disabled ? "" : url}
            style={location.pathname === url ? { color: theme.palette.primary.main } : {}}
            className={classes.link + (disabled ? " "+classes.disabled : "")}
        >
            <ListItemButton selected={location.pathname === url} disabled={disabled} sx = {sx}>
                {Icon ? 
                    <ListItemIcon style={{ color: iconColor, minWidth: "39px" }}>
                        <Icon style={{ color: iconColor }} />
                    </ListItemIcon>
                : null}
               
                <ListItemText primary={label} className={classes.text}/>
            </ListItemButton>
        </Link>
    );
}